export const REGIONS_API_URL = 'api.contactUs.regions';
export const CONTACT_LIST_API_URL = 'api.contactUs.contactusCall';
export const REASONS_API_URL = 'api.cmsForms.fieldsets';
export const REQUIRED_ERROR_MESSAGE = 'requiredError';
export const COMMENT_ERROR_MESSAGE = 'commentMessageError';
export const EMAIL_REGEX_ERROR = 'emailRegexError';
export const EMAIL_SUCCESS_MESSAGE = 'emailRegexSuccess';
export const SEND_EMAIL_SUCCESS_MESSAGE = 'emailRegexSuccess';
export const SEND_EMAIL_FAIL_MESSAGE = 'emailFailMessage';
export const REASON_NOT_FOUND = 'reasonNotFound';
// eslint-disable-next-line
export const EMAIL_REGEX =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const TEXT_MAX_LENGTH = 80;
export const COMMENT_MAX_LENGTH = 2000;
export const HOME = 'HOME'; // redirect to home page
export const COUNTRY = 'country'; // to get country details from JSON contract
export const DEFAULT_REGION_ID = 'AMR';
export const FORM_IDENTIFIER = {
    // these are form keys which is using for internal user
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    EMAIL: 'email',
    REASON: 'reason',
    COMMENTS: 'comments',
};
